<template>
<nav @click="$emit('click', $event)" :class="position">
  <div><router-link to="/">Home</router-link></div>
  <div><router-link to="/program">Program</router-link></div>
  <!-- <div><router-link to="/bulletin">Bulletin</router-link></div> -->
  <div><router-link to="/about">About</router-link></div>
  <div><router-link to="/atlas">Atlas</router-link></div>
  <div><router-link to="/tags">Tags</router-link></div>
  <div @click.stop>
    <div v-if="links.instagram"><a target="_blank" :href="`https://instagram.com/${links.instagram}`">Instagram</a></div>
    <div v-if="position !== 'top'"><a target="_blank" href="https://www.artspace.org.au">Artspace</a></div>
    <form class="sub" @submit="onSubmit" action="https://artspacesydney.createsend.com/t/j/s/egjdd/" method="post" target="_blank">
      <span v-if="submitted">
        <input placeholder="Thanks!" key="thanks" class="thanks"/>
      </span>
      <span v-else>
        <input :placeholder="placeholder" @focus="subscribeFocused = true" @blur="subscribeFocused = false" key="email" name="cm-egjdd-egjdd" v-model="email" />
        <icon-arrow class="arrow" @click.native="onClickArrow" v-if="email.length"></icon-arrow>
      </span>
      <button type="submit" ref="button" v-show="false" />
    </form>
  </div>
</nav>
</template>

<script>
import Vue from 'vue'
import iconArrow from '!vue-svg-loader!../../static/images/arrow.svg'

export default Vue.component('NavItems', {
  components: {
    iconArrow
  },
  props: ['position'],
  data: () => ({
    subscribeFocused: false,
    submitted: false,
    email: ''
  }),
  methods: {
    onSubmit(event) {
      this.submitted = true
    },
    onClickArrow(event) {
      this.$refs.button.click()
    }
  },
  computed: {
    placeholder() {
      if(this.subscribeFocused) {
        return 'name@email.com'
      } else {
        return 'Subscribe'
      }
    },
    links() {
      const { state: { site: { data } } } = this.$store
      return {
        instagram: data.instagram,
        youtube: data.youtube,
        vimeo: data.vimeo,
        twitter: data.twitter,
        facebook: data.facebook,
        soundcloud: data.soundcloud
      }
    }
  }
})
</script>

<style scoped lang="scss">
@import '~@/_variables.scss';

.top {
  a:hover {
    color: $color-white;
  }
}

.bottom {
  .sub input::placeholder {
    color: $color-white;
  }
}

.sub {
  @media (min-width: #{$break-small+1}) {
    margin-top: -0.1em;
  }
  input {
    background: none;
    border: none;
    outline: none;
    color: $color-gray;
    text-transform: uppercase;
    &:focus::placeholder {
      color: $color-gray;
    }
    &:focus + .arrow-container {
      visibility: visible;
    }
    &::placeholder {
      color: $color-black;
    }
  }
  .thanks {
    pointer-events: none;
  }
  .arrow {
    height: 0.8em;
    width: auto;
    transform: rotate(-90deg);
    position: relative;
    top: 0.1rem;
    &-container {
      cursor: pointer;
    }
    /deep/ path {
      stroke: $color-gray;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/nav-items.vue